import { queryOptions } from "@tanstack/react-query";
import { getCurrentUser } from "../api";

export const currentUserQuery = queryOptions({
  queryKey: ["authentication", "current-user"],
  queryFn: getCurrentUser,
  staleTime: 30_000,
  retry: false,
});
